import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    background-color: #FFFFFF;
    flex-direction: column;
    font-family: Work Sans;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #3C4D4F;
    gap: 1em;
`;

export const SectionWrapper = styled.div`
    background-color: #FFFFFF;
    padding: 1em 0;
`;

export const DealInfoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1em;
    padding: 0 1em;
`;

export const DealInfoLeftWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1em;
    width: 40%;
`;

export const DealInfoRightWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: baseline;
    width: calc(60% - 1em);
    max-height: 520px;
`;

export const DealInfoChartBox = styled.div`
    border: 0.5px solid #3C4D4F;
    background-color: #FAFAFA;
    width: 100%;
    height: 100%;
`;

export const TitleText = styled.div`
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0em;
    text-transform: uppercase;
    color: #5F6368;
`;

export const DealInfoStyledBox = styled.div`
    display: flex;
    flex-direction: column;
    border: 0.5px solid #3C4D4F;
    background-color: #FAFAFA;
    padding: 1em;
    max-width: 320px;
    gap: 1em;
`;

export const DealInfoBoxRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #5F6368;
`;

export const TwoTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const DescriptionText = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 12px;
    font-size: 12px;
`;

export const ValueText = styled.div`
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
`;

export const ValuationSensitivitySectionWrapperTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 1em 1em 1.5em 1em;
`;

export const ValuationSensitivitySectionWrapperBottom = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 1em 0 0 0;
`;

export const ValuationSensitivityPaddingWrapper = styled.div`
    padding: 0 1em;
    display: flex;
    flex-direction: column;
    gap: 1em;
`;

export const DottedLine = styled.div`
    height: 1px;
    border-bottom: 1px dotted #3C4D4F;
`;

export const ValSensitivityToCapRateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1em;
`;

export const ValSensitivitySubText = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #5F6368;
`;

export const ValSensitivitySubTextBold = styled.b`
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: #000000;
`;

export const ValSensitivityToCapRateBoxesWrapper = styled.div`
    display: table;
    width: 100%;
`;
